import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Employeur } from 'src/app/shared/models/employeur';
import { PARAM_LABEL_BENEFICIAIRE } from 'src/app/core/services/constant/constants.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';

@Component({
	selector: 'app-employeur-modal-ajout-form',
	templateUrl: './employeur-modal-ajout-form.component.html',
	styleUrls: ['./employeur-modal-ajout-form.component.scss']
})
export class EmployeurModalAjoutFormComponent implements OnInit {
	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	isPreferencesActive = false;

	employeur = new Employeur();

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = new FormGroup({
		nomStructure: new FormControl('', [
			Validators.required,
		]),
		addressStructure: new FormControl(new Address().label, [
			//Validators.maxLength(60)
		]),
		typeEntreprise: new FormControl(),
		siret: new FormControl(''),
		codeNaf: new FormControl(''),
		lastNameContact1: new FormControl('', [
			Validators.minLength(1),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		firstNameContact1: new FormControl('', [
			Validators.minLength(1),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		fonctionContact1: new FormControl(),
		telephoneContact1: new FormControl('', Validators.pattern('0{1}[0-9]{9}')),
		emailContact1: new FormControl('', [Validators.email]),
		lastNameContact2: new FormControl('', [
			Validators.minLength(1),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		firstNameContact2: new FormControl('', [
			Validators.minLength(1),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		fonctionContact2: new FormControl(),
		telephoneContact2: new FormControl('', Validators.pattern('0{1}[0-9]{9}')),
		emailContact2: new FormControl('', [Validators.email]),
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	@Output() updateListing = new EventEmitter();


	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private toastService: ToastService
	) {}

	ngOnInit(): void {
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		this.facade.employeurService
			.addEmployeur(this.employeur)
			.subscribe({
				next: (addedEmployeurId: number) => {
					this.employeur.id = addedEmployeurId;
					this.isValidateButtonClicked.value = false;
					this.bsModalRef.hide();
					this.updateListing.emit(this.employeur);
				},
				error: (err: ErrorResponse) => {
					this.isValidateButtonClicked.value = false;
					this.toastService.createHttpErrorToast(
						err.error.message,
						err.status
					);
				}
			});
	}
}
